import { useState, useEffect } from 'react';
import { initMercadoPago, getIdentificationTypes } from '@mercadopago/sdk-react';

/**
 * Initializes MercadoPago SDK, obtains identification types,
 * retrieves the updated campaign, and filters allowed payment methods
 * based on the campaign total.
 */
const useMercadoPagoSetup = ({
  campaign,
  paymentMethods,
  creatingCampaign,
  matchCampaign,
  campaignCreated,
  getCampaign,
  getMercadoPagoPaymentMethods,
  onIdentificationTypesLoaded
}) => {
  const [identificationTypes, setIdentificationTypes] = useState([]);
  const [paymentMethodsAllowed, setPaymentMethodsAllowed] = useState([]);

  // Init MP + identification types + fetch updated campaign
  useEffect(() => {
    const mercadoPagoPublicKey = process.env.REACT_APP_MERCADO_PAGO_PUBLIC_KEY;

    if (campaign) {
      (async () => {
        try {
          initMercadoPago(mercadoPagoPublicKey);
          const types = await getIdentificationTypes();
          setIdentificationTypes(types);
          if (types.length > 0) onIdentificationTypesLoaded(types[0].id);
        } catch (error) {
          console.error('Error fetching identification types:', error);
        }
      })();
    }

    if (paymentMethods.length === 0) {
      try {
        getMercadoPagoPaymentMethods();
      } catch (error) {
        console.error('Error fetching payment methods:', error);
      }
    }

    try {
      if (matchCampaign) {
        getCampaign(matchCampaign);
      } else if (campaignCreated && campaignCreated.id) {
        getCampaign(campaignCreated.id);
      }
    } catch (error) {
      console.error('Error fetching campaign:', error);
    }
  }, [creatingCampaign, matchCampaign]);

  // Filter payment methods based on the campaign total
  useEffect(() => {
    if (paymentMethods.length < 1 || !campaign) return;

    const allowed = paymentMethods
      .filter(pm => pm.payment_type_id !== 'credit_card' && pm.payment_type_id !== 'debit_card')
      .filter(
        pm =>
          pm.id !== 'transfer' &&
          pm.min_allowed_amount <= campaign.total_price_with_profit &&
          pm.max_allowed_amount >= campaign.total_price_with_profit
      );

    setPaymentMethodsAllowed(allowed);
  }, [paymentMethods, creatingCampaign]);

  return { identificationTypes, paymentMethodsAllowed };
};

export default useMercadoPagoSetup;
